<template>
  <section class="light-vide-section">
    <b-container>
      <b-row>
        <b-col sm="12" md="6" lg="5">
          <div class="text-vide-container">
            <h3 class="title-box">{{$t('light_towers')}}</h3>
            <p class="msg-box">
              {{$t('msg_video_text')}}
            </p>
            <a class="link-more" target="_blank" href="https://lighttowers.io/">{{$t('more')}}</a>
          </div>
        </b-col>
        <b-col sm="12" md="6" lg="7">
          <div class="video-container" style="width: 100%">
              <video :src="videoUrl" controls poster="@/assets/img/poster-video-light-towers.jpg" width="100%">
                Your browser does not support the video tag.
              </video>
            </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
export default {
  data () {
    return {
      videoUrl: require('@/assets/video/light-towers.mp4')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "@/assets/sass/app.scss";

.light-vide-section{
  padding-top: 80px;
  padding-bottom: 40px;
  background: #20201E;
  .text-vide-container{
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      gap: 10px;
    .title-box{
      color: #F2E682;
      font-family: $main-font;
      font-size: 40px;
      font-style: normal;
      font-weight: 700;
      line-height: 48px;
      margin: 0 0 40px 0;
      @media screen and (min-width: 320px) {
        font-size: 24px;
        line-height: 28px;
        margin: 0 0 24px 0;
      }
      @media screen and (min-width: 768px) {
        font-size: 40px;
        font-weight: 700;
        line-height: 48px;
        margin: 0 0 40px 0;
      }
    }
    .msg-box{
      color: #96D6DF;
      font-family: $main-font;
      font-size: 20px;
      font-style: normal;
      font-weight: 600;
      line-height: 28px;
      margin: 0 0 20px 0;
      @media screen and (min-width: 320px) {
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 22.4px;
        margin: 0 0 24px 0;
      }
      @media screen and (min-width: 991px) {
        font-size: 20px;
        font-weight: 600;
        line-height: 28px;
        margin: 0 0 20px 0;
      }
    }
    .link-more{
      color: #F2E682;
      font-family: $main-font;
      font-size: 20px;
      font-style: normal;
      font-weight: 600;
      line-height: 140%;
      &:hover{
        outline: none;
        text-decoration: none;
        transform: scale(1.05);
      }
    }
  }
  .video-container {
    position: relative;
    padding-bottom: 56.25%; /* 16:9 аспектне відношення */
    padding-top: 30px;
    height: 0;
    overflow: hidden;
    video {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      @media screen and (min-width: 320px) {
      }
      @media screen and (min-width: 768px) {
      }
      @media screen and (min-width: 1440px) {
      }
      @media screen and (min-width: 1920px) {
      }
    }
  }
}
</style>
